import { IMAGES } from "../constants/image";

const NotFound = () => {
  return (
    <div className="h-screen w-screen bg-white">
      <img
        src={IMAGES?.Notfound}
        alt="Not Found Image"
        className="h-full w-1/2 mx-auto sm:w-full bg-white object-contain"
      />
    </div>
  );
};

export default NotFound;
